var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 663.147,
    height: 206.823,
    viewBox: "0 0 663.147 206.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M2.593,99.017a92.09,92.09,0,1,1,1.873,18.574A92.09,92.09,0,0,1,2.593,99.017Z",
    transform: "translate(-2.593 -7.02)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logoapprovemgi",
    transform: "translate(-1145.803 -189.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    transform: "translate(1146.95 -46.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_577",
    transform: "translate(233 236.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_478",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_474",
    transform: "translate(2.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1192",
    d: "M179.945-23.9H163.416l-.386,1.081-1.467,7.183-.386,1.081-.7,3.939v1.081l-.7,2.163L159.4-5.9h11.817a9.211,9.211,0,0,0,7.878-6.488h0l1.081-4.325v-.7l1.081-5.02.386-1.467Z",
    transform: "translate(-3.694 23.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1193",
    d: "M160.6,3.5h-4.634L140.9,74.943h5.02A13.414,13.414,0,0,0,158.51,64.516L171.408,3.5Z",
    transform: "translate(0.518 17.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1194",
    d: "M7.308,62.824l18.3-39.081L14.877,74.718H29.629L42.141,15.865a11.463,11.463,0,0,0-1.467-9.732A10.2,10.2,0,0,0,31.714,2.58a16.412,16.412,0,0,0-4.325.386,14.257,14.257,0,0,0-10.736,8.959L-2.038,50.312l-.309-38.386A8.716,8.716,0,0,0-9.529,2.889a16.953,16.953,0,0,0-3.939-.309A17.516,17.516,0,0,0-23.9,6.133a17.514,17.514,0,0,0-5.715,9.732L-42.2,74.718h14.752l10.736-50.975,1.467,38.077.386,5.02c0,1.081.386,2.549.386,3.553.7,3.553,3.939,6.488,7.569,6.1a10.852,10.852,0,0,0,9.654-5.406l.386-.386a34.389,34.389,0,0,0,2.549-3.939Z",
    transform: "translate(42.2 17.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1195",
    d: "M66.494,63a10.926,10.926,0,0,0,.386,3.553,7.5,7.5,0,0,0,3.939,5.715,19.4,19.4,0,0,0,10.736,2.549h17.61a17.857,17.857,0,0,0,16.142-8.65,23.87,23.87,0,0,0,3.244-9.654l4.634-22.63H105.961l-1.776,7.878h1.776L103.1,55.735v.386c-.7,2.163-2.549,3.244-5.715,3.244h-12.2c-1.467-.386-2.549-1.467-2.549-2.549v-.386L90.205,21.6a3.874,3.874,0,0,1,3.553-2.858H122.1l3.244-15.447H96.307A23.161,23.161,0,0,0,81.941,7.386a24.789,24.789,0,0,0-6.8,13.671S67.267,58.748,66.88,60.215A8.354,8.354,0,0,0,66.494,63Z",
    transform: "translate(17.461 17.715)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1451",
    d: "M-45,36.5",
    transform: "translate(45 10.15)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    width: 447.95,
    height: 125.7,
    transform: "translate(1360 255)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dashboardlogocompletw",
    transform: "translate(1027.95 -261.451)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "DASHBOARD",
    transform: "translate(346 630.451)",
    fill: "#fff",
    fontSize: 90,
    fontFamily: "Young"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "APPROVE"))), /*#__PURE__*/React.createElement("g", {
    id: "Logo-BG-Approve",
    transform: "translate(1143.21 183.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6",
    "data-name": "Groupe 6",
    transform: "translate(2.593 6.912)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 92.194,
    cy: 92.194,
    r: 92.194,
    transform: "translate(0 0)",
    fill: "#004b93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0 0.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 200.791,
    height: 129.806,
    transform: "translate(-11.699 -31.375)",
    fill: "#0094cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(36.627 22.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M75.514,12.616a55.726,55.726,0,0,1,27.75,12.889c-2.373,2.162-4.67,4.407-6.89,6.676a46.372,46.372,0,1,0,15.872,26.605,81.313,81.313,0,0,1,8.6-5.157A55.991,55.991,0,1,1,75.509,12.616",
    transform: "translate(-10.713 -11.917)",
    fill: "#004b93",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M16.057,51.751A55.8,55.8,0,0,1,38.363,42.2c5.251,8.279,9.559,19.494,10.353,26.943C66.622,46,88.979,17.314,110.063,13.082A94.264,94.264,0,0,0,103.915,43.5C81.277,50.145,59.692,75.963,44.8,93.193,39.544,79.235,29.952,58.6,16.057,51.751",
    transform: "translate(8.06 -7.817)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "AP",
    transform: "translate(38.813 157.162)",
    fill: "#fff",
    fontSize: 70,
    fontFamily: "Young",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.05em"
  }, "P")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveLogo2);
export default __webpack_public_path__ + "static/media/Approve_logo2.8ccef3c756210bd37d9dd988f09597f8.svg";
export { ForwardRef as ReactComponent };